import React from 'react';
import withLayout from '../../components/layout/index';
import MyCarsList from '../../components/feature/my-cars-list/index';
const MyCars = () => {
    return (
        <MyCarsList />
    );
};

export default withLayout(MyCars, true, true, { search: false, wisList: false, notification: false, title: 'MY BIDS' });
